import { useDeviceIdentifier } from './useDeviceIdentifier';
import { Identifier } from '../services/config/config';

interface DeviceData {
  serialNumber?: string,
  assetTag?: string,
  imei?: string,
  deviceName?: string
}

export function useFormatDeviceIdentifier(data: DeviceData | undefined): string {
  const { label: identifierLabel, id: identifierId } = useDeviceIdentifier();

  const unavailable = 'n/a';
  const valueMap: Record<Identifier, string | undefined> = {
    [Identifier.assetTag]: data?.assetTag,
    [Identifier.IMEI]: data?.imei,
    [Identifier.deviceName]: data?.deviceName,
    [Identifier.serialNumber]: data?.serialNumber
  };

  const value = valueMap[identifierId] || unavailable;
  const label = identifierId === Identifier.serialNumber ? 'SN' : identifierLabel;

  return `(${label}: ${value})`;
}
